import { HotelSearchForm } from "@/features/hotels/components/HotelSearchForm/HotelSearchForm";
import { useHotelSearchDataContext } from "@/features/hotels/contexts/HotelSearchDataContext";

export const HotelSearchHeader = () => {
  const { searchData, updateSearchData } = useHotelSearchDataContext();

  return (
    <div className="rounded-4xl bg-surface-base-light p-3 shadow-sm">
      <HotelSearchForm
        variant="compact"
        initialValues={{
          dates: searchData!.dates,
          rooms: searchData!.rooms,
          destination: null,
        }}
        analyticsSource="sticky"
        onChange={(values) => {
          updateSearchData((prev) => {
            if (!prev) {
              return null;
            }

            return {
              ...prev,
              dates: values.dates,
              rooms: values.rooms,
            };
          });
        }}
      />
    </div>
  );
};
